import { Project, ProjectsState } from 'src/store/state/projects';

export const createProjectExportState = (
  project: Project,
  // redux-persist version
  version: number
): { state: { projects: ProjectsState }; version: number } => {
  const projectsState: ProjectsState = {
    projectsById: {
      [project.id]: project,
    },
    projectIds: [project.id],
    pendingFileUploadsByProjectId: {},
    pendingVirtualGraphsByProjectId: {},
    pendingAutoGenerateResourceIdsByProjectId: {},
    pendingAutoGenerateMockDataByProjectId: {},
  };

  return {
    state: {
      projects: projectsState,
    },
    version,
  };
};
